import Control from 'ol/control/Control';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faMap } from "@fortawesome/free-solid-svg-icons";

class BasemapSwitcherControl extends Control {
    constructor(options) {
      // Create a button element
      const button = document.createElement('button');
      button.innerHTML = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="map" class="svg-inline--fa fa-map fa-w-18 fa-xs " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="cursor: pointer;font-size: 0.75em;height: 1em;"><path fill="currentColor" d="M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"></path></svg>';
      button.title = 'Basemap Switcher';
  
      // Styling the button (matches default zoom control style)
      button.style.cursor = 'pointer';
      button.style.marginTop = '60px'; // Space between zoom controls and this button
      button.style.position = 'absolute'; 

      if(!!options.handler) {
        button.addEventListener('click', options.handler);
      }
      /*
      // Add click event
      button.addEventListener('click', () => {
        alert('Custom button clicked!');
      });
        */
      // Wrap the button in a div
      const element = document.createElement('div');
      element.className = 'ol-zoom ol-control'; // Same container style as ol-zoom
      element.appendChild(button);
  
      // Pass to the Control superclass
      super({
        element: element,
        target: options.target,
      });
    }
  }


  export default BasemapSwitcherControl;